/* mc-home.js — ported 1:1 from sections/moodycontacts-direct-home/moodycontacts-direct-home.html:170-209 */
(function () {
  document.querySelectorAll('.mc-home .mcsh .flip').forEach(function (card) {
    var front = card.querySelector('.face.front');
    var back = card.querySelector('.flipback');
    if (front) {
      front.addEventListener('click', function () { card.classList.add('on'); });
      front.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.classList.add('on'); }
      });
    }
    if (back) {
      back.addEventListener('click', function (e) { e.stopPropagation(); card.classList.remove('on'); });
    }
  });

  /* scroll-linked horizontal carousels: as the page scrolls down, each [data-hscroll]
     row advances to the right. Only active while the row overflows (i.e. on mobile). */
  function initHScroll() {
    var rows = Array.prototype.slice.call(document.querySelectorAll('[data-hscroll]'));
    if (!rows.length) return;
    var ticking = false;
    function place() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      rows.forEach(function (el) {
        var max = el.scrollWidth - el.clientWidth;
        if (max <= 4) return; // not overflowing (desktop) -> leave alone
        var r = el.getBoundingClientRect();
        var prog = (vh - r.top) / (vh + r.height); // 0 entering bottom -> 1 leaving top
        prog = prog < 0 ? 0 : (prog > 1 ? 1 : prog);
        el.scrollLeft = max * prog;
      });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(place); }
    }, { passive: true });
    window.addEventListener('resize', place);
    place();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHScroll);
  else initHScroll();
})();
